module.exports = __webpack_public_path__ + "static/media/menu-team.5f773a86.png";